export default "__VITE_ASSET__DNhyEy6i__"